import { render, staticRenderFns } from "./msgbox.vue?vue&type=template&id=0f15d08a&scoped=true"
import script from "./msgbox.vue?vue&type=script&lang=js"
export * from "./msgbox.vue?vue&type=script&lang=js"
import style0 from "./msgbox.vue?vue&type=style&index=0&id=0f15d08a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15d08a",
  null
  
)

export default component.exports